import { render } from "./SchedulesDetailsSettings.vue?vue&type=template&id=30b68971&scoped=true"
import script from "./SchedulesDetailsSettings.vue?vue&type=script&lang=js"
export * from "./SchedulesDetailsSettings.vue?vue&type=script&lang=js"

import "./SchedulesDetailsSettings.vue?vue&type=style&index=0&id=30b68971&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b68971"]])

export default __exports__